import React from "react";
import { ClientRowData, ClientAdjustmentRecord } from "../types";

interface HistoryModalProps {
    showHistory: boolean;
    setShowHistory: (show: boolean) => void;
    historyTarget: ClientRowData | null;
    historyRows: ClientAdjustmentRecord[];
    isHistoryLoading: boolean;
    cycleYear: number;
}

export const HistoryModal: React.FC<HistoryModalProps> = ({
    showHistory,
    setShowHistory,
    historyTarget,
    historyRows,
    isHistoryLoading,
    cycleYear,
}) => {
    if (!showHistory || !historyTarget) return null;

    return (
        <div style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 50 }}>
            <div style={{ background: "#fff", borderRadius: "14px", width: "460px", maxWidth: "92vw", padding: "26px", maxHeight: "88vh", overflowY: "auto" }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div>
                        <div style={{ fontSize: "16px", fontWeight: 700, color: "#1e293b" }}>Histórico de reajustes</div>
                        <div style={{ fontSize: "13px", color: "#64748b", marginTop: "2px" }}>
                            {historyTarget.clientFantasyName} · {historyTarget.clientCodeCnx}
                        </div>
                    </div>
                    <button
                        onClick={() => setShowHistory(false)}
                        style={{ width: "32px", height: "32px", borderRadius: "8px", border: "1px solid #e2e8f0", background: "#fff", cursor: "pointer", fontSize: "15px", color: "#64748b" }}
                    >
                        ✕
                    </button>
                </div>

                <div style={{ marginTop: "18px", display: "flex", flexDirection: "column", gap: "8px" }}>
                    {isHistoryLoading ? (
                        <div style={{ padding: "24px", textAlign: "center", color: "#64748b", fontSize: "13px" }}>
                            Carregando histórico...
                        </div>
                    ) : historyRows.length === 0 ? (
                        <div style={{ padding: "24px", textAlign: "center", color: "#94a3b8", fontSize: "13px" }}>
                            Nenhum reajuste registrado para este cliente.
                        </div>
                    ) : (
                        historyRows.map((h, idx) => {
                            const y = h.cycleYear ?? h.year;
                            const isCurrent = y === cycleYear;
                            const dateStr = h.createdAt ? new Date(h.createdAt).toLocaleDateString("pt-BR") : "";

                            return (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justify: "space-between",
                                        background: isCurrent ? "#f0fdfa" : "#fff",
                                        border: `1px solid ${isCurrent ? "#ccfbf1" : "#e2e8f0"}`,
                                        borderRadius: "10px",
                                        padding: "12px 14px",
                                    }}
                                >
                                    <div>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            <span style={{ fontSize: "14px", fontWeight: 700, color: "#1e293b" }}>Ciclo {y}</span>
                                            {isCurrent && (
                                                <span style={{ fontSize: "10px", fontWeight: 700, color: "#0f766e", background: "#ccfbf1", borderRadius: "20px", padding: "2px 8px" }}>
                                                    Vigente
                                                </span>
                                            )}
                                        </div>
                                        {dateStr && <div style={{ fontSize: "11.5px", color: "#94a3b8", marginTop: "3px" }}>{dateStr}</div>}
                                        {h.comment && <div style={{ fontSize: "11.5px", color: "#64748b", marginTop: "2px" }}>{h.comment}</div>}
                                    </div>
                                    <span style={{ fontSize: "15px", fontWeight: 700, color: "#0d9488" }}>
                                        {h.adjustment.toFixed(2).replace(".", ",")}%
                                    </span>
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};
